// extracted by mini-css-extract-plugin
module.exports = {"label":"label__1qJ6w","input":"input__3mukh","required":"required__g5gkV"};